import React from "react";

const brRegex = /<br\s*[\/]?>/gi;
const newLineRegex = /\r?\n/;

export const getBreakText = (text: string) => {
  const strings = text.replace(brRegex, "\n").split(newLineRegex);

  return (
    <>
      {strings.map((str) => (
        <React.Fragment key={str}>
          {str}
          <br />
        </React.Fragment>
      ))}
    </>
  );
};
